import { EnvironmentOutlined } from '@ant-design/icons';
import { Card, Col, Row, Space, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import LoginForm from '../components/Auth/LoginForm';
import { useAuth } from '../contexts/AuthContext';
import { getActiveEnvironment, initializeEnvironmentTable } from '../services/environmentService';
import packageJson from '../../package.json';

const { Title, Text } = Typography;

const LoginPage = () => {
    const { isAuthenticated, loading } = useAuth();
    const [currentEnvironment, setCurrentEnvironment] = useState(null);

    useEffect(() => {
        loadEnvironmentInfo();
    }, []);

    const loadEnvironmentInfo = async () => {
        try {
            // Inicializar la tabla de entorno primero
            await initializeEnvironmentTable();
            const env = await getActiveEnvironment();
            setCurrentEnvironment(env);
        } catch (error) {
            console.error('Error cargando información del entorno:', error);
        }
    };

    // Si ya está autenticado, redirigir al inicio
    if (!loading && isAuthenticated()) {
        return <Navigate to="/" />;
    }

    return (
        <div style={{ padding: '24px', minHeight: '100vh', backgroundColor: '#f0f2f5' }}>
            <Row justify="center" align="middle" style={{ minHeight: '100vh' }}>
                <Col xs={24} sm={20} md={16} lg={12} xl={8}>
                    <Space direction="vertical" size="large" style={{ width: '100%' }}>
                        <div style={{ textAlign: 'center' }}>
                            <Title level={2}>Bienvenido a ExceliaOne</Title>
                            <Text type="secondary">Sistema de gestión empresarial</Text>
                        </div>

                        {currentEnvironment && (
                            <Card
                                size="small"
                                style={{
                                    backgroundColor: '#f6ffed',
                                    borderColor: '#b7eb8f',
                                    textAlign: 'center'
                                }}
                            >
                                <Space direction="vertical" size="small">
                                    <Space>
                                        <EnvironmentOutlined style={{ color: '#52c41a' }} />
                                        <Text strong style={{ color: '#52c41a' }}>
                                            Entorno Actual
                                        </Text>
                                    </Space>
                                    <div>
                                        <Text strong>{currentEnvironment.company}</Text>
                                        <br />
                                        <Text type="secondary" style={{ fontSize: '12px' }}>
                                            {currentEnvironment.env}
                                        </Text>
                                    </div>
                                </Space>
                            </Card>
                        )}

                        <LoginForm />

                        <div style={{ textAlign: 'center' }}>
                            <Text type="secondary" style={{ fontSize: '12px' }}>
                                Versión {packageJson.version} - Sistema de sincronización avanzado
                            </Text>
                        </div>
                    </Space>
                </Col>
            </Row>
        </div>
    );
};

export default LoginPage; 